import {
  MAKRKETPLACE_IMAGE_MAP,
  type MarketplaceKey,
} from '@/constants/marketplaceImage';
import { SALE_PILL_LABELS } from './OfferProductPreview.constants';
import type {
  OfferBannerData,
  OfferPreviewInput,
  SalePillState,
} from './OfferProductPreview.types';

export function offerBannerNeedsLiveClock(data: OfferBannerData): boolean {
  return data.kind === 'PRICE_TIMER' || data.kind === 'TIMER';
}

export function marketplaceLogoForBrand(brand: string): string | undefined {
  const keys = Object.keys(MAKRKETPLACE_IMAGE_MAP) as MarketplaceKey[];
  const hit = keys.find((k) => k.toLowerCase() === brand.trim().toLowerCase());
  return hit ? MAKRKETPLACE_IMAGE_MAP[hit] : undefined;
}

/**
 * Sale-pill state for the tile. Driven by the per-offer `isSale` flag rather
 * than the offer type — admins can surface the pill on any offer kind.
 * Returns null when the offer is not flagged on sale.
 */
export function getSalePillState(
  input: OfferPreviewInput,
  now: Date
): SalePillState | null {
  if (!input.isSale) return null;

  if (!input.isActive) {
    return {
      variant: 'muted',
      label: SALE_PILL_LABELS.paused,
      showDot: false,
    };
  }
  const end = input.endsAt ? new Date(input.endsAt) : null;
  if (end && end < now) {
    return {
      variant: 'ended',
      label: SALE_PILL_LABELS.saleEnded,
      showDot: false,
    };
  }
  if (input.offerType === 'SALE' && !end) {
    return {
      variant: 'muted',
      label: SALE_PILL_LABELS.setEndTime,
      showDot: false,
    };
  }
  return {
    variant: 'live',
    label: SALE_PILL_LABELS.saleLive,
    showDot: true,
  };
}
